<template>
  <div class="professional-group-form">
    <b-form-group label="Название профгруппы">
      <b-input v-model="value.name" />
    </b-form-group>
  </div>
</template>

<script>
import ProfessionalGroupModel from "@/components/Forms/Union/ProfessionalGroup/models/professionalGroupModel";

export default {
  props: {
    value: {
      type: ProfessionalGroupModel,
      required: true
    }
  }
};
</script>
